<template>
  <div class="bg-container-blue">
    <v-carousel :height="null" hide-controls>
      <v-carousel-item
        v-for="(newsItem, index) in important_posts"
        :key="index"
      >
        <v-layout column class="cm-header position-relative">
          <v-flex xs12 class="image-background d-flex align-center justify-center">
            <img
              :src="newsItem.main_image"
              alt="News image"
              class="post-image-mobile"
              @click="goToShowPost(newsItem)"
            />
          </v-flex>

          <v-flex xs12 class="blue-background-mobile">
            <div class="overlay-text" style="width:100%;">
              <p class="white--text title-text">
                <b>{{ newsItem.title }}</b>
              </p>
              <button class="btn-outlined-white" @click="goToShowPost(newsItem)">Conoce más</button>
            </div>
          </v-flex>
        </v-layout>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  methods: {
    ...mapActions("posts", ["fetchImportantPosts"]),
    goToShowPost(post) {
      this.$router
        .push({ name: "post-show", params: { slug: post.slug } })
        .catch((e) => {});
    },
  },
  computed: {
    ...mapState("posts", ["important_posts"]),
  },
  beforeMount() {
    if (!this.important_posts.length) {
      let view_as = localStorage.getItem("view_as");
      this.fetchImportantPosts(view_as);
    }
  },
};
</script>

<style scoped>
.post-image-mobile {
  width: 100%;
  height: 200px;
  object-fit: cover;
}
.blue-background-mobile{
  background: url("https://assets-intranet-security.s3.us-east-2.amazonaws.com/fnd-cuadrille-azul+BICE+1.jpg");
  background-size: cover;
  padding: 5%;
}

</style>